import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules'

const init = store => {  
  store.commit('SET_HEADERS');
  console.log('plugin');
};

Vue.use(Vuex)

export default new Vuex.Store({
  modules,
  plugins: [init]
})
